import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';

const isDev = window.location.hostname === 'localhost' || window.location.hostname === '192.168.15.57';
axios.defaults.baseURL = isDev ? 'http://localhost:3001' : (process.env.REACT_APP_API_URL || 'https://app.plenariumdigital.com.br');

// Garante que NENHUM Service Worker fique controlando esta aplicaÃ§Ã£o.
// O SW antigo interceptava atÃ© requisiÃ§Ãµes do socket.io, causando falhas
// intermitentes de conexÃ£o em tempo real (cronÃ´metro, votaÃ§Ã£o, etc.).
// Esta lÃ³gica roda em TODA carga de pÃ¡gina e desregistra qualquer SW
// encontrado, mesmo que tenha sido registrado hÃ¡ meses.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => {
      registration.unregister();
    });
  }).catch(() => {});

  if ('caches' in window) {
    caches.keys().then(keys => {
      keys.forEach(key => caches.delete(key));
    }).catch(() => {});
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
